import React from 'react'
import { object, func } from 'prop-types'
import { Line } from 'react-chartjs-2'
import { withContext } from '../../../utils/withContext'
import styles from './UserWeightPage.styl'
// import { validateDate, convertDate } from '../../../actions/validations'

class UserWeightPage extends React.Component {
	static propTypes = {
		athlete: object,
		handleSubmit: func,
		context: object
	}
	constructor(props) {
		super(props)
		this.state = { weight: '', date: new Date() }
		this.newWeight = this.newWeight.bind(this)
	}
	weightHistory() {
		const { athlete } = this.props
		if (athlete.weightHistory) {
			return athlete.weightHistory.map((data, i) => (
				<tr key={ i }>
					<td>{ data.weight }</td>
					<td>{ new Date(data.date).toISOString().slice(0, 10).split('-').reverse().join('-') }</td>
				</tr>
			)).reverse()
		} else { return null }
	}
	newWeight(e) {
		e.preventDefault()
		const { weight, date } = this.state
		const { athlete } = this.props
		const newDate = date.getTime()
		let data
		if (athlete.weightHistory) {
			data = {
				...athlete,
				currentWeight: {
					weight,
					date: newDate
				},
				weightHistory: [
					...athlete.weightHistory,
					{
						weight,
						date: newDate
					}
				]
			}
		} else {
			data = {
				...athlete,
				currentWeight: {
					weight,
					date: newDate
				},
				weightHistory: [
					{
						weight,
						date: newDate
					}
				]
			}
		}

		if (!weight) {
			// TODO: ALERT!!
			return
		}
		this.props.handleSubmit(e, data)
	}
	getMonthDays(month, year) {
		if (month.match(/^0|2|4|6|7|9|11/)) { return 31 } else if (month.match(/3|5|8|10/)) { return 30 } else if (year % 4 !== 0) { return 28 } else if (year % 100 !== 0 || year % 400 === 0) { return 29 } else { return 28 }
	}
	handleChange(e) {
		const date = new Date(this.state.date.getTime())
		const newMonth = e.target.value - 1
		const monthDays = this.getMonthDays(newMonth.toString())
		if (date.getDate() > monthDays) { date.setDate(monthDays) }
		date.setMonth(newMonth)
		this.setState({ date })
	}
	render() {
		const { date, weight } = this.state
		const { athlete, context: { i18n } } = this.props
		const days = new Array(this.getMonthDays(date.getMonth().toString())).fill().map((v, i) => <option key={ i } value={ i + 1 }>{ i + 1 }</option>)
		const month = new Array(12).fill().map((v, i) => <option key={ i } value={ i + 1 }>{ i + 1 }</option>)
		const years = new Array(new Date().getFullYear() - 1920).fill().map((v, i) => <option key={ i } value={ new Date().getFullYear() - i }>{ new Date().getFullYear() - i }</option>)
		return (
			<div className={ styles.dataBox }>
				<div className={ styles['content'] }>
					<form onSubmit={ this.newWeight }>
						<h2 className={ styles.title }>{ i18n`weight_evolution_label` }</h2>
						<div className={ styles.table }>
							<h4>{ i18n`insert_weight_label` }</h4>
							<table>
								<thead>
									<tr>
										<th>{ i18n`registry_weigth_label` }</th>
										<th>{ i18n`date_label` }</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td><input type="number" step="0.1" min="0" value={ weight } placeholder="0" onChange={ (e) => { this.setState({ weight: parseFloat(e.target.value) }) } } /></td>
										<td>
											<div className={ styles['dadosContainer'] } >
												<select value={ this.state.date.getDate() } onChange={ (e) => this.setState({ date: new Date(date.setDate(e.target.value)) }) }>
													{ days }
												</select>
												<select value={ this.state.date.getMonth() + 1 } onChange={ (e) => this.setState({ date: new Date(date.setMonth(e.target.value)) }) }>
													{ month }
												</select>
												<select value={ this.state.date.getFullYear() } onChange={ (e) => this.setState({ date: new Date(date.setFullYear(e.target.value)) }) }>
													{ years }
												</select>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
							<div className={ styles.concluded }>
								<input type="submit" value={ i18n`new_weight_label` } />
							</div>
						</div>

						<div className={ styles.table }>
							<h4>{ i18n`weight_history_label` }</h4>
							<Line
								legend={ {
									display: false
								} }
								data={ {
									labels: ((athlete || {}).weightHistory || []).sort((a, b) => a.data - b.date).map(ele => {
										const graphDate = new Date(ele.date)
										return `${ graphDate.getDate() }/${ graphDate.getMonth() }/${ graphDate.getFullYear() }`
									}),
									datasets: [
										{
											fill: false,
											lineTension: 0.1,
											backgroundColor: '#f26522',
											borderColor: '#f26522',
											borderCapStyle: 'butt',
											borderDash: [],
											borderDashOffset: 0.0,
											borderJoinStyle: 'miter',
											pointBorderColor: 'rgba(51,51,51,1)',
											pointBackgroundColor: '#fff',
											pointBorderWidth: 5,
											pointHoverRadius: 5,
											pointHoverBackgroundColor: '#f26522',
											pointHoverBorderColor: 'rgba(220,220,220,1)',
											pointHoverBorderWidth: 2,
											pointRadius: 1,
											pointHitRadius: 10,
											data: ((athlete || {}).weightHistory || []).sort((a, b) => a.data - b.date).map(ele => ele.weight)
										}
									]
								} }
							/>
							{/* { (athlete || {}).weightHistory ?
								<table>
									<thead>
										<tr>
											<th>{ i18n`registry_weigth_label` } (kg)</th>
											<th>{ i18n`date_label` }</th>
										</tr>
									</thead>
									<tbody>
										{ this.weightHistory() }
									</tbody>
								</table> :
								<p>{ i18n`no_data_label` }</p>
							} */}
						</div>
					</form>
				</div>
			</div>
		)
	}
}

export default withContext(UserWeightPage)



// WEBPACK FOOTER //
// ./src/client/webapp/pages/UserWeightPage/UserWeightPage.js